@if (shouldShow) {
  <app-clearance [clearanceKey]="'ekh'" [clearance]="clearance">
    @if (channelBound) {
      <div>This vessel is constrained by draught</div>
    }
    @if (tideRestricted) {
      <div>The registered vessel is tidal restricted</div>
    }
  </app-clearance>
}
